import React from "react";

export const Barbell = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_805_462)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 13.125H3.5V14.875H0V13.125ZM9.625 13.125H18.375V14.875H9.625V13.125ZM24.5 13.125H28V14.875H24.5V13.125Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.25 6.125C5.25 5.64175 5.64175 5.25 6.125 5.25H10.5C10.9832 5.25 11.375 5.64175 11.375 6.125V21.875C11.375 22.3582 10.9832 22.75 10.5 22.75H6.125C5.64175 22.75 5.25 22.3582 5.25 21.875V20.125H2.625C2.14175 20.125 1.75 19.7332 1.75 19.25V8.75C1.75 8.26675 2.14175 7.875 2.625 7.875H5.25V6.125ZM7 21H9.625V7H7V21ZM5.25 9.625H3.5V18.375H5.25V9.625ZM16.625 6.125C16.625 5.64175 17.0168 5.25 17.5 5.25H21.875C22.3582 5.25 22.75 5.64175 22.75 6.125V7.875L25.375 7.875C25.6071 7.875 25.8296 7.96719 25.9937 8.13128C26.1578 8.29538 26.25 8.51794 26.25 8.75L26.25 19.25C26.25 19.7332 25.8582 20.125 25.375 20.125H22.75V21.875C22.75 22.3582 22.3582 22.75 21.875 22.75H17.5C17.0168 22.75 16.625 22.3582 16.625 21.875V6.125ZM22.75 18.375H24.5L24.5 9.625H22.75V18.375ZM21 7H18.375V21H21V7Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_805_462">
          <rect width="28" height="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
